import { useEffect, useRef } from 'react';

const useOpenKpiaModalEvent = (onOpen) => {
  const onOpenRef = useRef(onOpen);

  useEffect(() => {
    onOpenRef.current = onOpen;
  }, [onOpen]);

  useEffect(() => {
    const handleOpenKpiaModal = () => {
      if (onOpenRef.current) {
        onOpenRef.current();
      }
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('openKpiaModal', handleOpenKpiaModal);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('openKpiaModal', handleOpenKpiaModal);
      }
    };
  }, []);
};

export default useOpenKpiaModalEvent;
